<template>
  <div class="ColumnRoute rounded-lg overflow-hidden bg-white sticky top-4">
    <p class="ColumnName py-4 text-center text-white bg-primary">
      {{ columnName }}
    </p>

    <div class="Columnlinks flex flex-col p-4 space-y-4 rounded-b-lg">
      <router-link
        v-for="route in routes"
        :key="route.path"
        class="flex justify-between items-center rounded-lg"
        :to="{ name: route.name }"
      >
        {{ route.meta.title }}
        <i class="el-icon-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import { constantRoutes } from "@/router/index";
import { parentRoute } from "@/utils";

export default {
  name: "ColumnRoute",
  computed: {
    columnMatched: function () {
      const matched = this.$route.matched.map((d) => ({
        name: d.name,
        path: d.path,
        meta: d.meta,
      }));

      // 一级路由
      return matched.splice(0, 1);
    },
    columnName: function () {
      return this.columnMatched[this.columnMatched.length - 1].meta.title;
    },
    routes: function () {
      return parentRoute(constantRoutes, this.columnMatched);
    },
  },
};
</script>

<style lang="scss" scoped>
.ColumnRoute {
  width: 298px;
}
.ColumnName {
  font-size: 28px;
}
.Columnlinks {
  $color: rgba(50, 128, 75, 1);

  border: 1px solid #d7d7d7;
  border-top: 0;
  a {
    padding: 14px 20px 14px 24px;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    line-height: 28px;
    background-color: rgba(47, 173, 106, 0.2);
    transition: all 0.3s;
    &.router-link-active {
      background-color: $color;
      color: white;
    }
    &:hover {
      background-color: $color;
      color: white;
    }
  }
}
</style>
